import { useEffect, useMemo } from 'react';
import type { ReactNode } from 'react';
import { AccountantContext } from '@/contexts/accountantContext.ts';
import { getAccountantExternalId } from '@/contexts/accountantExternalId.ts';
import { redirectToLogin } from '@/services/redirectToLogin.ts';

interface AccountantProviderProps {
  children: ReactNode;
}

export const AccountantProvider = ({ children }: AccountantProviderProps) => {
  const value = useMemo(() => ({ accountantExternalId: getAccountantExternalId() }), []);

  useEffect(() => {
    if (!value.accountantExternalId) {
      redirectToLogin();
    }
  }, [value.accountantExternalId]);

  if (!value.accountantExternalId) {
    return null;
  }

  return <AccountantContext value={value}>{children}</AccountantContext>;
};
